import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'tdesign-react';

import NovaDialog from '@/components/dialog';

import Rename from '../../components/rename';
import SpineWebPlayer from '../../core/player/spine';
import { ISpineResult } from '../../folder';
import { SpinePlayerRef } from '..';
import styles from './index.module.less';

interface SpineDialogProps {
  config?: any;
  visible: boolean;
  value: ISpineResult;
  disabled?: boolean;
  onClose: () => void;
  onConfirm: (value: any) => void;
}

const SpineDialog: React.FC<SpineDialogProps> = ({
  config,
  visible,
  value,
  disabled = false,
  onClose,
  onConfirm,
}) => {
  const [name, setName] = useState<string | undefined>(value.directoryName);
  const [loading, setLoading] = useState<boolean>(false);
  const playerRef = useRef<SpinePlayerRef>(null);

  useEffect(() => {
    if (!visible) {
      setName(value.directoryName || '未命名');
    }
  }, [value.directoryName, visible]);

  const handleConfirm = async () => {
    try {
      setLoading(true);
      let newThumbnail = value.thumbnail;
      const animation = playerRef?.current?.getAnimation();
      // if (animation !== value.animation) {
      //   newThumbnail = await playerRef?.current?.getImage();
      // }
      newThumbnail = await playerRef?.current?.getImage(); // TODO：临时放开一段时间这里的限制，让用户完成spine的更新，后面改回来
      onConfirm({
        ...value,
        animation,
        directoryName: name,
        ...(newThumbnail ? { thumbnail: newThumbnail } : {}),
      });
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const getHeader = () => (
    <div className={styles.modalTitle}>
      <span style={{ flexGrow: 1 }}>Spine预览</span>
    </div>
  );

  const dialogConfig = {
    visible,
    closeBtn: false,
    width: 'fit-content',
    onCancel: onClose,
    onConfirm: handleConfirm,
    destroyOnClose: true,
    header: getHeader(),
    confirmBtn: (
      <Button theme='primary' disabled={disabled} loading={loading} onClick={handleConfirm}>
        确定
      </Button>
    ),
    cancelBtn: (
      <Button theme='default' onClick={onClose}>
        取消
      </Button>
    ),
  };

  return (
    <NovaDialog dialogConfig={{ ...dialogConfig, ...config }}>
      <div className={styles.spineWrap}>
        <div style={{ width: 'fit-content', minWidth: 0, maxWidth: '100%' }}>
          <Rename
            value={name || '未命名'}
            disabled={disabled}
            onChange={setName}
          />
        </div>
        <SpineWebPlayer
          value={value}
          disabled={disabled}
          playerRef={playerRef}
        />
      </div>
    </NovaDialog>
  );
};

export default SpineDialog;
